import { render } from "./app-logo-senangpay.vue?vue&type=template&id=0cd71a52"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-senangpay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cd71a52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cd71a52', __exports__)) {
    console.log('reload')
    api.reload('0cd71a52', __exports__)
  }
  
  module.hot.accept("./app-logo-senangpay.vue?vue&type=template&id=0cd71a52", () => {
    console.log('re-render')
    api.rerender('0cd71a52', render)
  })

}


export default __exports__